export const numberSubtitle = "Enter Mobile Number";
export const sendButton = "SEND";
export const loading = "LOADING...";
